import { useMutation } from "@tanstack/react-query";
import { updateSevenRoomsClientTagSettings } from "../../api/bSevenroomsApi";

export const useUpdateSevenRoomsClientTagSettings = () => {
  return useMutation({
    mutationKey: ["update-sevenrooms-client-tag-settings"],
    mutationFn: (data) => updateSevenRoomsClientTagSettings(data),
    onError: (error) => {
      console.error("SevenRooms client tag settings error:", error.response || error);
    },
  });
};
